import React from 'react';
import Box from '@mui/material/Box';

import { IS_DEV_ENV, DEV_ACCENT } from '../../constants/env';

/**
 * Marca permanente de entorno no productivo.
 *
 * Existe porque desde que hay dos backends desplegados las dos webs son idénticas por
 * dentro: sin una marca visible, un tester reporta contra dev creyendo que es prod, o
 * al revés.
 *
 * Va montado UNA vez en `index.js`, fuera de `App`, para que cubra de golpe el
 * dashboard de administración, el portal de directores —que no usa `AppBar` sino su
 * propio sidebar— y las páginas públicas (invitación de clubes, reportes públicos).
 *
 * Son DOS piezas y no una a propósito. El armazón de la app ya se pinta de ámbar en
 * dev (`APP_BAR_COLOR`), pero el login no tiene ni barra ni sidebar, y es justo la
 * pantalla en la que el tester decide contra qué entorno está entrando:
 *
 * - la franja superior se ve en cualquier pantalla, incluido el login, y en las que sí
 *   tienen barra queda ámbar sobre ámbar, o sea invisible y sin estorbar;
 * - el sello de esquina es el que sobrevive a una captura recortada.
 *
 * Las dos llevan `pointerEvents: 'none'`, que es la lección de `ViewAsBanner`: aquel
 * aviso acabó tapando los botones de acción de cada página. La esquina elegida es la
 * inferior izquierda porque la derecha es donde caen los FAB.
 *
 * En producción no renderiza nada.
 */
export function EnvBadge() {
  if (!IS_DEV_ENV) return null;

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 6,
          zIndex: theme => theme.zIndex.tooltip + 1,
          pointerEvents: 'none',
          backgroundColor: DEV_ACCENT,
        }}
      />
      <Box
        sx={{
          position: 'fixed',
          bottom: 14,
          left: 14,
          zIndex: theme => theme.zIndex.tooltip + 1,
          pointerEvents: 'none',
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          backgroundColor: DEV_ACCENT,
          color: '#ffffff',
          fontSize: 13,
          fontWeight: 800,
          letterSpacing: '0.1em',
          boxShadow: 3,
        }}
      >
        DEV
      </Box>
    </>
  );
}
